export default {
  "journeyDuration": "预计路程时长",
  "durationMinutes": "{minutes} 分钟",
  "estimatedArrivalPreview": "预计送达：",
  "commonDestinationPlaceholder": "输入或选择常用送达地点",
  "dateGroupSummary": "{count} 位 · 按可接送时间排序",
  guestAssignedContactsHint: '以下是本班次为您安排的接送人员，如需调整请提前联系。',
  navigate: '导航',
  smsShort: '短信',
  mixedLocationsTitle: "嘉宾接送地点不同",
  mixedLocationsHint: "所选嘉宾包含不同的机场/车站：{locations}。请确认是否合并安排，并在创建页面核实接人地点。",
  continueArrangement: "确认并继续",
  locationSerial: "序号",
  "locationTitle": "接送地点管理",
  "locationMenu": "接送配置",
  "locationSubtitle": "维护企业常用的接人、送达地点，创建接送安排时可直接选用。",
  "locationAdd": "新增接送地点",
  "locationEdit": "编辑接送地点",
  "locationCount": "共 {count} 个地点",
  "locationSearch": "搜索地点 / 地址 / 引导 / 备注",
  "locationName": "地点名称",
  "locationNameHint": "如：白云机场 T2 到达厅",
  "locationAddress": "详细地址",
  "locationAddressHint": "选填，填写具体地址、出站口或集合点",
  "locationRegion": "省市区",
  "locationRegionHint": "请选择省、市、区",
  "locationGuidance": "线路引导",
  "locationGuideLabel": "线路引导说明",
  "locationGuideHint": "填写抵达路线、集合步骤或注意事项",
  "locationViewGuide": "查看说明",
  "locationRemarkHint": "选填，如停车或等候说明",
  "locationSave": "保存地点",
  "locationSaved": "接送地点已保存",
  "locationNameRequired": "请输入地点名称",
  "locationDeleteHint": "确定删除「{name}」吗？已保存的接送安排文字不会改变。",
  "locationLoadFailed": "地点加载失败，请重试",
  "noLocations": "暂无接送地点，请点击右上角新增",
  "locationImageSize": "图片不能超过10MB",
  "notificationResend": "重新发送",
  "notificationResendConfirm": "确认向 {name}（{phone}）重新发送接送通知？上次状态：{status}。预计再次使用 {units} 条短信额度。",
  "notificationResendUnknownWarning": "已查询，上次发送结果仍未知，嘉宾可能已经收到短信。继续可能重复送达并再次扣费。",
  "notificationResendStale": "发送记录已变化，请刷新后重试",
  "notificationResendBusy": "当前仍有通知排队或发送中，请稍后重试",
  "notificationResendCooldown": "距离上次发送不足一分钟，请稍后刷新再试",
  "notificationResendSingle": "重新发送一次只能选择一位嘉宾",
  "notificationResendQueryRequired": "请先查询最新发送结果，并确认结果未知时重复发送的风险",
  "importConfirmTitle": "确认添加接送嘉宾",
  "importConfirmHint": "请核对以下 {count} 位嘉宾的信息。确认后加入待导入名单，保存任务后生效。",
  "confirmGuestSelection": "确认选择",
  "pickupNotSet": "尚未填写，请在保存任务前设置",
  "noLinkedMeeting": "未关联会议日程",
  "submittedAtLabel": "报名时间",
  "importSelectionChanged": "嘉宾信息或筛选结果已变化，请重新核对选择",
  "call": "呼叫",
  "callPerson": "呼叫{name}",
  "invalidContactPhone": "未填写有效联系电话",
  "driverTaskTag": "接送安排 · 司机 / 接送人员接送链接",
  "taskStaffHeading": "任务组成员",
  "driverRole": "接送司机",
  "driverContactRole": "接送司机 · 兼任嘉宾对接",
  "accompanyingRole": "随车人员",
  "phoneNotProvided": "未填写号码",
  "tripArrangementHeading": "行程安排",
  "driverGuestsHeading": "接送嘉宾",
  "driverPickedSummary": "已接到 {picked} / {total} 位",
  "driverPendingSummary": "待接 {pending} 位 · 已回流 {returned} 位",
  "confirmPickupFor": "确认接到{name}",
  "undoPickupFor": "取消{name}的接到标记",
  "driverInteractionHint": "点击嘉宾左侧方框，核对信息后确认接到，系统自动记录时间；再次点击已勾选方框可取消误标。点击“呼叫”可直接拨号。",
  "allPeriods": "全部时段",
  "allPositions": "全部职务 / 身份",
  "allMeetings": "全部会议日程",
  "resetFilters": "重置筛选",
  "period_morning": "上午（00:00–11:59）",
  "period_afternoon": "下午（12:00–17:59）",
  "period_evening": "晚上（18:00–23:59）",
  "transferDate": "接送日期",
  "timeMissing": "未填写时间",
  "taskSearch": "任务 / 车牌 / 人员 / 手机号",
  "rosterSearch": "姓名 / 手机号 / 单位 / 班次",
  "filteredJourneyCount": "共 {total} 条 · 筛选可见 {count} 条",
  "rosterTotals": "当前嘉宾 {current} 位 · 历史回流 {returned} 条",
  "currentGuests": "当前任务嘉宾",
  "currentGuestCount": "当前嘉宾数",
  "returnHistoryCount": "历史回流记录",
  "allPickupStates": "全部接送状态",
  "filteredRosterCount": "筛选名单 {count} 条 / 全部 {total} 条",
  "exportFilteredRoster": "导出筛选名单",
  "printFilteredRoster": "打印筛选名单",
  "transferSheet": "接送安排表",
  "generatedAt": "生成时间",
  "reportScope": "名单范围",
  "reportTaskCount": "共 {count} 个接送任务",
  "role": "角色",
  "pickedAtColumn": "接到时间",
  "feedbackDetails": "回流反馈 / 后续安排",
  "signatureLine": "司机签字：____________　接待签字：____________　嘉宾确认：____________　日期：____________",
  "printPreview": "打印预览",
  "printLayoutHint": "A4 横向 · 每个任务单独起页，长名单自动分页并重复表头。请在系统打印窗口选择打印机或保存为 PDF。",
  "printFailed": "无法打开打印窗口，请重试或检查浏览器打印设置",
  "noReportItems": "暂无可导出或打印的接送安排",
  "eventName": "活动名称",
  "manualGuestTag": "手动添加",
  "manualGuestDuplicate": "该手动嘉宾已提交，请刷新名单后重试",
  "filterAll": "全部",
  "importRoster": "导入嘉宾名单",
  "guestName": "嘉宾姓名",
  "addGuest": "添加嘉宾",
  "completedRosterLocked": "已完成任务不能维护嘉宾名单",
  "rosterRemovalHint": "从任务移除后，报名嘉宾返回原待安排队列；手动嘉宾不生成报名记录。已接到的嘉宾不能移除。",
  "importRosterHint": "选择当前活动中同一行程方向的待安排或回流待安排嘉宾，确认保存后加入本任务。",
  "confirmImportRoster": "确认导入",
  "manualNameRequired": "请填写嘉宾姓名",
  "rosterRequired": "请至少添加一位接送嘉宾",
  "feedbackMissed": "反馈未接到嘉宾",
  "selectAllMissed": "全选未接到嘉宾",
  "returnReasonType": "未接到原因",
  "returnNote": "补充说明（其他原因必填）",
  "returnReason_delay": "行程延误",
  "returnReason_personal": "临时事务耽误",
  "returnReason_absent": "未到集合点",
  "returnReason_other": "其他",
  "feedbackReporter": "反馈人员",
  "undoPicked": "取消接到标记",
  "undoPickedSuccess": "已取消接到标记",
  "undoPickedConfirm": "确认取消「{name}」的接到标记？",
  "pickupTimestampHint": "请核对嘉宾和接送地点。确认后自动记录接到时间；误操作可取消接到标记。",
  "returnFeedbackRequired": "请选择嘉宾、未接到原因，并补充必要说明",
  "apiRosterRetain": "请至少保留一位接送嘉宾",
  "apiRosterCompleted": "已完成任务不能维护嘉宾名单",
  "apiRosterRemove": "只能移除当前任务内的嘉宾，请刷新名单",
  "apiRosterProtected": "已接到或有本任务回流记录的嘉宾不能移除",
  "apiReasonRequired": "请选择未接到原因",
  "apiOtherNote": "选择其他原因时请填写补充说明",
  "apiReadyBefore": "预计可接时间不能早于本趟接人时间",
  "apiChooseSubmission": "请选择一种嘉宾提交方式",
  "apiPickupSingle": "接到状态请逐人确认",
  "incompleteReturn": "回流记录不完整，请核实原任务后重新安排",
  "invalidReturnTask": "回流嘉宾必须安排到有效的新任务",
  "changedJourney": "所选行程已变更，请刷新名单",
  "capacityHint": "座位数按车型中的“数字+座”识别，例如“商务车 · 7 座”；未填写座位数时无法校验载客人数。",
  "scheduleHint": "先填写接人与送达时间；同一车辆、司机或随车人员在重叠时段只能安排一项任务。",
  "scheduleConflict": "车辆或人员时间冲突，请更换资源或调整时间",
  "duplicateStaff": "司机和随车人员不能重复，请核对手机号",
  "capacityExceeded": "嘉宾人数超过车辆座位数，请拆分安排或更换车辆",
  "duplicateGuest": "同一嘉宾不能重复加入本次接送安排",
  "returnTooEarly": "回流再安排不得早于原任务送达时间及嘉宾最早可接时间",
  "returnLocationMismatch": "回流嘉宾接人地点与目标任务不一致，请按接人地点分别安排",
  "returnTaskPrefix": "回流接送 · ",
  "endTimeMissing": "结束时间未填写",
  "availability": "可用状态",
  "available": "可安排",
  "missingDriver": "缺少司机信息",
  "returnReadyAt": "最早可接时间",
  "returnPickupLocation": "回流接人地点",
  "returnDetailsHint": "确认未接到后进入回流待安排。可填写最早可接时间和接人地点，下一趟安排将据此校验。",
  "nextArrangement": "后续安排",
  "noNextArrangement": "尚未重新安排",
  "noJoinableTask": "暂无符合方向、接人时间、地点及座位数要求的任务，请创建新安排",
  "alreadyPickedReturn": "已接到的嘉宾不能标记为未接到",
  "guestContact": "对接人员",
  "guestContactPhone": "对接人员电话",
  "selectedGuestCount": "已选 {count} 位嘉宾",
  "chooseGuestContact": "选择随车人员",
  "batchGuestContact": "批量指派随车人员",
  "batchAssignContacts": "批量指派",
  "guestAssignmentHint": "勾选嘉宾后批量指派，或在名单中逐人选择；未指派时默认第一位随车人员。",
  "defaultGuestContact": "未指派（默认 {name}）",
  "driverContactName": "司机 {name}（自动对接）",
  "driverContactPending": "选择车辆后由司机自动对接",
  "assignContactFor": "为 {name} 指派对接人员",
  "automaticContact": "自动对接",
  "guestAssignmentUnavailable": "嘉宾对接人员指派暂不可用，请联系管理员完成配置后重试",
  "guestAssignmentScope": "只能指派当前任务中选定的嘉宾，请刷新名单",
  "guestAssignmentStaffScope": "对接人员必须从本次任务的随车人员中选择",
  "guestAssignmentDuplicateStaff": "本次任务的随车人员不能重复添加",
  "staffVerificationTitle": "接送人员身份验证",
  "staffVerificationHeading": "验证后查看接送任务",
  "staffVerificationIntro": "仅限本次任务的司机或随车人员使用。",
  "staffVerificationHint": "请输入工作人员为您登记的姓名和手机号，验证通过后查看嘉宾名单。",
  "verifyNameHint": "请输入本人的登记姓名",
  "verifyPhoneHint": "请输入本人的登记手机号",
  "verifyAndEnter": "验证并进入",
  "staffVerificationHelp": "如验证不通过，请联系活动工作人员核对本次任务的接送人员信息。",
  "staffVerificationPassed": "身份已验证",
  "changeIdentity": "切换身份",
  "staffVerificationRequired": "请填写姓名和手机号",
  "staffVerificationMismatch": "姓名或手机号与本次接送人员信息不匹配，请核对后重试",
  "staffVerificationExpired": "身份验证已失效，请重新输入姓名和手机号",
  "staffVerificationTooMany": "验证次数过多，请一分钟后再试",
  "staffTaskUnavailable": "接送任务暂时无法访问，请检查网络或联系工作人员确认链接是否有效。",
  "guestTravelTitle": "我的接送安排",
  "guestGreeting": "您好，{name}",
  "editTravelTime": "修改出行时间",
  "guestPrivateHint": "本页面仅展示您的接送安排；如需调整接送计划，请提前联系对接人员。",
  "guestServiceInactive": "您的接送需求或报名状态已变化，请联系活动工作人员核实。",
  "guestChangePending": "出行信息已更新，原接送计划待工作人员核实；请以工作人员确认的安排为准。",
  "guestWaiting": "接送安排待确认",
  "guestReturnWaiting": "未接到，等待重新安排",
  "guestWaitingHint": "工作人员正在核实接送安排，请稍后刷新本页面查看最新信息。",
  "guestNeedsVerification": "待核实",
  "yourContacts": "您的接送人员",
  "driverShort": "司机",
  "staffShort": "随车",
  "driverAndContact": "接送司机 · 兼任嘉宾对接",
  "yourStaff": "您的随车人员",
  "callContact": "呼叫",
  "vehicleInformation": "车辆信息",
  "checkPlate": "请认准此车牌上车",
  "journeyPlan": "行程安排",
  "yourReturnHistory": "您的接送记录",
  "guestRearranged": "已重新安排，最新信息见上方",
  "guestContactHint": "如需调整接机或接站安排，请联系您的随车人员；未分配随车人员时由司机对接。",
  "refreshMyTrip": "刷新我的安排",
  "guestLinkInvalid": "暂时无法查看接送安排",
  "guestLinkHelp": "请检查网络并刷新；如链接已失效，请向活动工作人员索取新的专属链接。",
  "guestTimeEditHint": "修改后会同步更新您的报名出行时间。车辆和计划接送时间不自动改变，将由工作人员核实。",
  "guestTimeSaved": "出行时间已更新，接送安排将由工作人员核实",
  "guestTimeFailed": "出行时间保存失败，请稍后重试",
  "guestTimeLocked": "当前行程不可修改，请联系活动工作人员",
  "guestTimeConflict": "行程信息已更新，请刷新后重新修改",
  "guestLinksUnavailable": "嘉宾链接功能暂不可用，请联系管理员完成配置后重试",
  "driverTaskLink": "司机 / 接送人员接送链接",
  "driverTaskLinkHint": "可查看本班次全部嘉宾名单并确认接到或未接到，仅供本次司机与接送人员使用。",
  "guestPersonalLinks": "嘉宾出行链接",
  "guestLinkSearch": "搜索姓名 / 手机号 / 单位",
  "guestLinkPrivacyHint": "每位嘉宾一个专属链接，请逐人发送；嘉宾只能查看本人的接送信息。",
  "guestLinkFor": "{name} 的专属接送链接",
  "qrCode": "二维码",
  "preview": "预览",
  "resourceSetupHelp": "暂时无法添加车辆、随车人员或生成邀请链接。配置完成后，点击“刷新”即可使用。",
  "resourceRetryHelp": "请检查网络后点击“刷新”；如仍无法加载，请联系管理员。",
  "resourceUnavailableEmpty": "暂时无法显示资料，请稍后刷新重试",
  "emptyVehicles": "暂无车辆，请点击右上角“添加车辆”，或通过邀请链接让司机登记",
  "emptyStaff": "暂无随车人员，请点击右上角添加，或通过邀请链接登记",
  "scanToRegister": "扫码填写登记信息",
  "inviteHelp": "将链接或二维码发送给登记人。提交成功后，刷新列表即可查看登记资料。",
  "continueRegistration": "继续登记",
  "pickupTimeLabel": "接人时间",
  "pickupLocationLabel": "接人地点",
  "dropoffLocationLabel": "送达地点",
  "taskInformation": "任务信息",
  "routeSectionHint": "接人、送达时间与地点",
  "taskNameExample": "如：首都机场 T3 接机 → 天河体育馆",
  "pickupArrangement": "接人安排",
  "dropoffArrangement": "送达安排",
  "chooseDateTime": "请选择日期和时间",
  "pickupPlaceExample": "根据嘉宾填写的到达地点带入，也可手动填写",
  "autoPickupTitle": "自动录入，支持手动修改",
  "autoPickupHint": "根据所选嘉宾填写的到达地点自动填入，可手动修改出站口和集合点。",
  "autoPickupMultiple": "所选嘉宾有多个地点，请手动确定本趟接人地点；输入框可选择已有地点。",
  "autoPickupEmpty": "所选嘉宾尚未填写地点，请手动填写本趟接人地点、出站口和集合点。",
  "destinationExample": "如：广州天河体育馆 东门",
  "noteDescription": "备注说明",
  "noteExample": "如：出站口看到指引牌后联系工作人员",
  "vehicleAndStaff": "车辆与随车人员",
  "vehicleAutofillHint": "选择车辆后自动带出司机",
  "transferVehicle": "接送车辆",
  "noVehicleChosen": "尚未选择接送车辆，请选择车辆或手动填写",
  "manualVehicle": "手动填写车辆及司机信息",
  "optionalMultiple": "选填，可多选",
  "driverFallbackHint": "未分配随车人员时，由司机负责对接嘉宾。",
  "removeStaffPerson": "移除随车人员 {name}",
  "transferGuestList": "接送嘉宾名单",
  "guestListCount": "共 {count} 位 · 司机与接待人员均可查看",
  "travelMode": "出行方式",
  "flightTrain": "航班 / 车次",
  "noData": "暂无数据",
  "saveArrangement": "保存接送安排",
  "vehicleSearch": "搜索车牌、车型、司机姓名或电话",
  "selectResource": "选择",
  "routeVehicleRequired": "请填写接人地点、预计送达时间、送达地点并选择或填写接送车辆",
  "arrivalAfterPickup": "预计送达时间必须晚于接人时间",
  "sourceIncomplete": "报名行程的乘坐工具、时间或班次尚未确定，请核实补全",
  "serviceDirection": "行程类型",
  "sourceDirectionChanged": "抵达与返程方向已改变，请先重新安排此行程",
  "invalidInput": "输入内容有误，请检查",
  "sessionExpired": "登录已过期，请重新登录",
  "forbidden": "您没有权限执行此操作",
  "notFound": "请求的资源不存在",
  "tooManyRequests": "操作过于频繁，请稍后再试",
  "serviceUnavailable": "服务暂不可用，请稍后重试",
  "serverError": "服务器内部错误，请联系管理员",
  "networkError": "网络异常，请稍后重试",
  "chooseFile": "选择文件",
  "noFileSelected": "未选择文件",
  "pageTitle": "接送配置",
  "tabLabel": "接送配置分类",
  "arrangements": "接送安排",
  "vehicles": "车辆管理",
  "receivers": "随车人员管理",
  "overview": "接送数据总览",
  "overviewScope": "全活动统计 · 不受下方列表筛选影响",
  "people": "人",
  "trips": "人次",
  "journeys": "条行程",
  "arrangementUnit": "个接送安排",
  "personUnit": "位人员",
  "requiredGuests": "需接送嘉宾",
  "pendingGuests": "待安排嘉宾",
  "planned": "计划接送",
  "picked": "已接到",
  "awaitingPickup": "待接到",
  "pickupProgress": "接到进度",
  "assignedSummary": "已安排 {people} 人 · 安排率 {rate}%",
  "returnedSummary": "其中回流待安排 {count} 条行程",
  "plannedNote": "回流人员重新安排后再计入计划",
  "pickedNote": "以嘉宾接到确认记录为准",
  "awaitingNote": "已安排，尚未确认接到",
  "progressNote": "已接到 / 计划接送",
  "tipResponsibility": "接送司机负责本班次，随车人员可选；未分配时由司机对接嘉宾",
  "tipDetails": "{responsibility}：记录接人时间与地点、预计送达时间与地点、车辆车牌号码以及本次需要接送的嘉宾名单。",
  "tipActions": "在「进行中」勾选任务后，可通过上方的「{export} / {print}」批量处理接送表（含司机、接待人员与全部嘉宾名单）；点任务上的「{taskLink}」可生成司机视角 / 嘉宾视角两个 H5 页面链接与二维码。",
  "arrangementStatus": "安排状态",
  "pending": "待安排",
  "returnedPending": "回流待安排",
  "returnedPinned": "{count} 条行程 · 置顶 · 按预计可接时间排序",
  "selectReturned": "全选回流人员",
  "ongoing": "进行中",
  "completed": "已完成",
  "pendingPeople": "待安排人员",
  "returnedPeople": "回流待安排人员",
  "listTotal": "共 {count} 条",
  "returnedSource": "司机或接送人员标记「未接到」的行程",
  "approvedSource": "已审核问卷中选择「需要接送」的行程",
  "refresh": "刷新",
  "create": "创建安排",
  "allTransport": "全部出行方式",
  "allNumbers": "全部航班班次",
  "allDates": "全部日期",
  "allOrganizations": "全部单位",
  "allServices": "全部服务",
  "arrivalService": "抵达 · 接机/站",
  "departureService": "返程 · 送机/站",
  "namePhone": "姓名 / 手机号",
  "selection": "已选 {selected} / 共 {total} 条",
  "selectFiltered": "全选当前筛选",
  "clearSelection": "清空选择",
  "nextTrip": "安排下一趟",
  "join": "加入现有任务",
  "pagination": "第 {page} / {pages} 页 · 每页 20 条",
  "selectPage": "选中本页",
  "selectJourney": "选择{name}{direction}行程",
  "arrival": "抵达",
  "departure": "返程",
  "arrivalTag": "抵达 · 接",
  "departureTag": "返程 · 送",
  "name": "姓名",
  "notPicked": "本次未接到",
  "serviceNumber": "出行班次",
  "scheduledTime": "预计抵达 / 返程时间",
  "notProvided": "未填写",
  "phone": "手机号",
  "organization": "单位",
  "position": "职务 / 身份",
  "meetings": "会议日程",
  "availablePickup": "预计可接时间",
  "timeNote": "行程在报名成功或审核通过时同步，刷新读取已保存的接送记录；待安排行程随报名修改同步更新。",
  "editArrangement": "编辑接送安排",
  "joinArrangement": "加入现有接送任务",
  "createArrangement": "创建接送安排",
  "selectedJourneys": "已选择 {count} 条{direction}行程",
  "transferTask": "接送任务",
  "chooseTask": "请选择进行中的同方向任务",
  "arrangementName": "安排名称",
  "pickupTime": "接送时间",
  "plannedArrival": "预计送达时间",
  "chooseVehicle": "选择车辆",
  "chooseVehicleHint": "从车辆管理中选择",
  "driverName": "司机姓名",
  "driverPhone": "司机电话",
  "vehiclePlate": "车辆 / 车牌",
  "carType": "车型 / 座位",
  "carTypeExample": "如：大巴车 · 45 座",
  "chooseReceivers": "选择随车人员",
  "chooseReceiversHint": "从随车人员管理中选择（可选）",
  "staff": "随车人员",
  "contactPhone": "联系电话",
  "delete": "删除",
  "addStaff": "添加随车人员",
  "pickupPlace": "接送地点",
  "destination": "目的地",
  "note": "备注",
  "taskStatus": "任务状态",
  "cancel": "取消",
  "confirmArrangement": "确认安排",
  "batchLimit": "单次最多操作 100 条行程，请缩小筛选范围",
  "separateDirections": "请分别选择抵达或返程行程进行安排",
  "arrivalName": "抵达接送安排",
  "departureName": "返程接送安排",
  "chooseTaskRequired": "请选择接送任务",
  "nameTimeRequired": "请填写安排名称和接送时间",
  "arrangementSaved": "接送安排已保存",
  "selectTasks": "全选任务",
  "selectedTasks": "已选 {count} 项",
  "export": "导出表格",
  "print": "打印表格",
  "filteredTasks": "筛选出 {count} 个 / 共 {total} 个接送安排",
  "departs": "出发 · 车牌",
  "viewRoster": "查看名单",
  "taskLink": "任务链接",
  "edit": "编辑",
  "associatedMeetings": "关联会议日程",
  "pickupDetails": "接人时间 / 地点",
  "dropoffDetails": "预计送达 / 地点",
  "plateColumn": "车辆车牌",
  "transferPeople": "接送人员",
  "driver": "司机",
  "accompanying": "随车",
  "returned": "已回流",
  "guestListLabel": "接送嘉宾",
  "personShort": "位",
  "moreGuests": "等 {count} 位",
  "noCompleted": "暂无已完成安排",
  "noOngoing": "暂无进行中的安排",
  "guestRoster": "接送嘉宾名单",
  "number": "班次",
  "formTime": "问卷预计时间",
  "pickupStatus": "接送状态",
  "taskLinkTitle": "司机 / 接送人员任务链接",
  "taskLinkHint": "将此链接提供给本次司机或随车接送人员，可在 H5 确认接到、标记未接到。",
  "copyLink": "复制链接",
  "openH5": "打开 H5",
  "task": "任务",
  "pickupAt": "接人时间",
  "pickupLocation": "接人地点",
  "dropoffAt": "送达时间",
  "dropoffLocation": "送达地点",
  "plate": "车牌",
  "carTypeCompact": "车型/座位",
  "guest": "嘉宾",
  "transport": "工具",
  "printBlocked": "请允许浏览器打开打印窗口",
  "deleteArrangementHint": "删除此安排后，未接送嘉宾将重新进入待安排。已有接到或回流记录的任务不能删除。",
  "deleteArrangement": "删除接送安排",
  "deleted": "已删除",
  "linkCopied": "链接已复制",
  "manualCopy": "请从输入框手动复制链接",
  "vehicle": "车辆",
  "resourceCountVehicles": "共 {count} 辆车辆",
  "resourceCountStaff": "共 {count} 位随车人员",
  "inviteLink": "邀请链接",
  "addResource": "添加{title}",
  "editResource": "编辑{title}",
  "noResources": "暂无数据，请点击右上角添加",
  "sequence": "序号",
  "vehiclePhoto": "车辆照片",
  "noPhoto": "暂无照片",
  "plateNumber": "车牌号码",
  "responsibleArea": "负责区域",
  "linkedTasks": "关联接送任务",
  "countTasks": "{count} 个",
  "actions": "操作",
  "remove": "移除",
  "save": "保存",
  "inviteTitle": "{title}登记邀请",
  "vehicleInviteHint": "邀请司机登记车辆照片、车牌、车型及联系方式。",
  "staffInviteHint": "邀请随车人员登记姓名、联系方式及负责区域。",
  "inviteH5Title": "{title}登记邀请 H5",
  "expiresAt": "有效期至 {time}",
  "close": "关闭",
  "taskName": "任务名称",
  "status": "状态",
  "resourcesFailed": "资源加载失败，请重试",
  "vehicleRequired": "请填写必填信息并上传车辆照片",
  "staffRequired": "请填写姓名和手机号",
  "invalidPhone": "请填写正确的手机号",
  "saved": "已保存",
  "removeVehicleHint": "确认删除该车辆？已关联任务的资源需先调整任务安排。",
  "removeStaffHint": "确认移除该随车人员？已关联任务的资源需先调整任务安排。",
  "removeResource": "移除接送资源",
  "removed": "已移除",
  "copied": "已复制",
  "awaitingPhoto": "待上传照片",
  "photoHint": "支持 JPG、PNG、WebP，单张不超过 10 MB",
  "plateExample": "如：粤A·12345",
  "driverNameHint": "请输入司机姓名",
  "driverContact": "司机联系电话",
  "phoneHint": "请输入手机号",
  "nameHint": "请输入姓名",
  "areaHint": "如：机场到达厅",
  "noteHint": "其他补充说明（选填）",
  "invalidPhoto": "请选择不超过 10 MB 的 JPG、PNG 或 WebP 图片",
  "registrationTitle": "{title}信息登记",
  "registrationHint": "请填写以下信息，提交后由活动工作人员安排接送。",
  "registered": "登记成功",
  "awaitStaff": "请等待工作人员安排接送",
  "submitRegistration": "提交登记",
  "invalidInvite": "登记链接无效或已过期，请联系活动工作人员",
  "registerFailed": "登记失败，请重试",
  "noPlate": "未填写车牌",
  "pickupLabel": "接人：",
  "dropoffLabel": "送达：",
  "driverLabel": "司机：",
  "staffLabel": "随车：",
  "h5Roster": "嘉宾名单 {count} 位",
  "h5Counts": "已接到 {picked} · 待接到 {pending} · 已回流 {returned}",
  "pickedAtTime": "已接到 {time}",
  "confirmPicked": "确认接到",
  "missed": "未接到",
  "noGuests": "暂无嘉宾",
  "refreshTask": "刷新任务",
  "taskFailed": "任务加载失败，请稍后重试",
  "missedConfirm": "确认本次未接到{name}？提交后将回流待安排。",
  "reasonHint": "填写原因（可选）",
  "reasonLimit": "原因最多255字",
  "pickedConfirm": "确认已接到{name}？",
  "pickupConfirmTitle": "接送确认",
  "returnedSuccess": "已回流待安排",
  "pickedSuccess": "已确认接到",
  "confirm": "确定",
  "notInitialized": "车辆与随车人员管理暂不可用，请联系管理员完成配置后重试",
  "duplicateResource": "该车辆或随车人员已登记，请勿重复添加",
  "linkedResourceError": "该资源已关联接送任务，请先调整任务安排",
  "validPlate": "请填写有效车牌号码",
  "photoSaveFailed": "照片保存失败，请重试",
  "inviteExpired": "登记链接无效或已过期",
  "waitingOnly": "只能安排待安排或回流待安排的行程，请刷新列表",
  "directionsError": "抵达与返程请分别创建安排",
  "taskChanged": "该任务已完成或行程方向不一致",
  "ongoingOnly": "只能操作进行中的接送行程",
  "deleteRecorded": "已有接到或回流记录的任务不能删除，请保留记录",
  "invalidVehicle": "所选车辆不存在或不属于当前活动",
  "invalidStaff": "所选随车人员不存在或不属于当前活动",
  "journeyChanged": "所选行程已变更、取消接送或不属于当前活动，请刷新列表",
  "completedLocked": "该接送任务已完成，不能修改接到状态",
  "guestChanged": "嘉宾已回流、重新安排或不属于当前任务，请刷新",
  "requestFailed": "操作失败，请稍后重试",
  "returnedPrefix": "已回流 ·",
  "sourceChanged": "报名信息已变更",
  "sourceChangedCount": "{count} 条报名信息发生变化，请查看名单核实后调整安排",
  "sourceChangeColumn": "报名变更",
  "sourceUpdated": "报名资料已修改",
  "sourceCancelled": "已取消接送或组件已停用",
  "sourceUnapproved": "报名已不处于审核通过状态",
  "sourceDeleted": "报名已删除",
  "sourceMoved": "报名已移至其他活动",
  "sourceKept": "原接送安排和确认时的行程保留，未自动回流。",
  "sourceInactiveHint": "此行程已不符合接送条件，保留历史记录，不再计入待接到人数。",
  "sourceField": "字段",
  "sourceBefore": "安排时",
  "sourceAfter": "最新报名",
  "applySource": "应用报名变更",
  "applySourceConfirm": "确认采用最新报名信息？车辆及接送时间地点保持原安排，请另行核实是否需要调整。",
  "sourceApplied": "已应用最新报名信息，接送安排保留",
  "snapshotNotInitialized": "接送任务同步尚未初始化，请先执行接送任务快照迁移并同步历史报名",
  "sourceAcknowledgeError": "只能确认仍需接送、尚未接到且进行中的报名变更，请刷新名单",
  "sourcePickupBlocked": "报名信息已变更，请联系工作人员确认后再操作",
  "notifyGuests": "通知嘉宾",
  "notificationIntro": "通过「嘉宾接待通知」短信模板发送专属接送链接，仅通知勾选的嘉宾。",
  "notificationTemplate": "短信模板",
  "notificationRecipients": "选择嘉宾",
  "notificationHistory": "发送记录",
  "notificationSelectEligible": "全选可通知嘉宾",
  "notificationSelection": "已选 {count} / {total} 位，预计使用 {units} 条短信额度（单次最多 100 位）",
  "notificationLastStatus": "通知状态",
  "notificationCreatedAt": "提交时间",
  "notificationDeliveredAt": "送达时间",
  "notificationQuery": "查询回执",
  "notificationSend": "发送接送通知",
  "notificationPreview": "短信内容预览",
  "notificationConfirm": "确认向 {count} 位嘉宾发送接送通知？预计使用 {units} 条短信额度，实际以发送记录为准。",
  "notificationQueued": "通知已提交发送队列，请在发送记录中查看结果。",
  "notificationRetryHint": "提交结果未确认，请先查看发送记录。再次提交相同选择会复用本次请求。",
  "notificationDeliveryHint": "已提交服务商不代表已送达；失败或跳过的记录可在刷新名单后重新勾选发送。结果未知时请先查询回执。",
  "notificationStorageUnavailable": "通知功能暂未初始化，请联系管理员完成配置。",
  "notificationSmsDisabled": "短信发送尚未开放，当前可预览内容和查看发送记录。",
  "notificationTemplatePending": "接送短信暂用占位模板，正式模板同步后可发送。",
  "notificationGatewayPending": "短信服务配置待同步，请联系管理员。",
  "notificationPublicUrlPending": "请先配置可公开访问的嘉宾 H5 地址，再发送短信。",
  "notificationJourneyChanged": "行程已变化、取消、接到或完成，请刷新名单后核实。",
  "notificationUnsupportedPhoneRegion": "暂不支持该区号，短信仅支持中国大陆手机号（+86）",
  "phone_region_unsupported": "暂不支持境外号码短信，仅支持中国大陆手机号（+86）",
  "notificationInvalidPhone": "手机号缺失或格式不正确",
  "notificationAlreadySubmitted": "当前安排已通知或正在发送，请先核实发送记录。",
  "notificationRequestChanged": "本次请求的名单发生变化，请刷新后重试。",
  "notificationQuotaInsufficient": "企业短信额度不足，本批次未发送。充值后刷新名单重新提交。",
  "notificationLoadFailed": "通知名单加载失败，请刷新后重试。",
  "notificationLimit": "单次最多通知 100 位嘉宾。",
  "notificationStatus_none": "未通知",
  "notificationStatus_pending": "待发送",
  "notificationStatus_queued": "已入队",
  "notificationStatus_sending": "发送中",
  "notificationStatus_sent": "已提交服务商",
  "notificationStatus_delivered": "已送达",
  "notificationStatus_submit_failed": "提交失败",
  "notificationStatus_failed": "发送失败",
  "notificationStatus_unknown": "结果未知",
  "notificationStatus_skipped": "已跳过",
  "notificationTemplateName": "嘉宾接待通知",
  "incompletePlan": "接送安排信息不完整，请补齐接人地点、送达时间、送达地点、车辆及司机信息",
  "invalidDriverContact": "请输入有效的司机联系电话",
  "unresolvedGuests": "任务仍有未处理的嘉宾，请先确认接到，或在司机/接送人员H5标记未接到后再完成任务",
  "invalidReceiverContact": "请补齐随车人员姓名和有效联系电话"
}
